interface ImageData {
    src: string
    alt: string
}

export function useImageRef(dataImage) {
    const imgDataSet = computed<ImageData>(() => {
        return {
            src:
                dataImage?.value?.getOriginal()?.getUrl() ||
                dataImage?.model?.data?.desktop?.links.site.href ||
                dataImage?.value?.model?.data?.desktop?.links.site.href ||
                dataImage?.model?.data?.original?.links?.site.href,
            alt: dataImage?.value?.model?.data?.altText || dataImage?.model?.data?.altText || '',
        }
    })

    return imgDataSet
}
